import React from 'react';
import { Button, Dropdown, Icon, List } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import type { IModelRecord } from '../types';

interface IActionCellProps {
  record: IModelRecord;
  loadingState: any;
  actionsDetail: IModelRecord  | null;
  onEdit: (record: IModelRecord) => void;
  onDetail: (uuid: string, name: string) => void;
  onAccess: (record: IModelRecord) => void;
  onDeleteClick: (record: IModelRecord) => void;
  onTest: (uuid: string) => void;
  onPublish: (uuid: string) => void;
  onUnpublish: (uuid: string) => void;
  onActionDetail: (record: IModelRecord) => void;
  formatMessage: (descriptor: { id: string; }, values?: Record<string, any>) => string;
}

const ActionCell: React.FC<IActionCellProps> = ({
  record,
  loadingState,
  actionsDetail,
  onEdit,
  onDetail,
  onAccess,
  onDeleteClick,
  onTest,
  onPublish,
  onUnpublish,
  onActionDetail,
  formatMessage,
}) => {
  const { permissions = {}, deployment_stage: stage, published_version: publishedVersion } = record;
  const { read, edit, test, publish, delete: deletePermission, access } = permissions as any;
  const { testLoading, publishLoading, unpublishLoading, } = loadingState || {};
  const isActins = actionsDetail?.uuid === record?.uuid;
  const stageButton: any = {
    draft: test ? (
      <Button className="table-btn dbl-model-management-actions-btn" type="link" onClick={() => onTest(record?.uuid)}>
        {isActins && testLoading ? <Icon type="loading" /> : formatMessage({ id: 'dbl_model_management_test' })}
      </Button>
    ) : null,
    tested: publish ? (
      <Button className="table-btn dbl-model-management-actions-btn" type="link" onClick={() => onPublish(record?.uuid)}>
        {isActins && publishLoading ? <Icon type="loading" /> : formatMessage({ id: 'dbl_model_management_publish' })}
      </Button>
    ) : null,
    published: publish ? (
      <Button className="table-btn dbl-model-management-actions-btn" type="link" onClick={() => onUnpublish(record?.uuid)}>
        {isActins && unpublishLoading ? <Icon type="loading" /> : formatMessage({ id: 'dbl_model_management_unpublish' })}
      </Button>
    ) : null,
  };

  const list = [
    edit && (
      <Button className="table-btn dbl-model-management-actions-btn" type="link" onClick={() => onEdit(record)}>
        {formatMessage({ id: 'dbl_model_management_edit' })}
      </Button>
    ),
    stageButton?.[stage || ''],
    publishedVersion && stage !== 'published' ? stageButton?.['published'] : null,
    read && <Button
      className="table-btn dbl-model-management-actions-btn"
      type="link"
      onClick={() => onDetail(record?.uuid, record?.name || '-')}
    >
      {formatMessage({ id: 'dbl_model_management_detail' })}
    </Button>,
    access && <Button
      className="table-btn dbl-model-management-actions-btn"
      type="link"
      onClick={() => onAccess(record)}
    >
      {formatMessage({ id: 'dbl_model_management_access' })}
    </Button>,
    deletePermission && <Button
      className={`table-btn dbl-model-management-actions-btn ${publishedVersion ? 'dbl-model-management-btn-disabled' : ''}`}
      type="link"
      onClick={() => {
        if (publishedVersion) return; // 已发布的模型不可删除
        onDeleteClick(record);
      }}
    >
      {formatMessage({ id: 'dbl_model_management_delete' })}
    </Button>,
  ]?.filter(v => v !== false && v !== null && v !== undefined);
  const showMoreBtn = list?.length > 2;
  return (
    <div className="dbl-model-management-actions-container" onClick={() => onActionDetail(record)}>
      {list?.[0]}
      {list?.[1]}
      {showMoreBtn && (
        <Dropdown trigger="click" placement="bottom-end" className='dbl-model-management-actions-btn-more' boxClassName={'dbl-model-management-actions-container-dropdown'}
          button={
            <>
              <div className="dbl-model-management-actions-container-dropdown-item">
                <div>{formatMessage({ id: 'dbl_model_management_more' })}</div>
                <SvgIcon type="fill-icon-arrow" />
              </div>
            </>
          }
          appearance="pure"
        >
          {() => (
            <List type="option">
              {
                list?.slice(2)?.map(item => item)
              }
            </List>
          )}
        </Dropdown>
      )}
    </div>
  );
};

export default ActionCell;


